@let formInstances = $formInstances();

<kendo-expansionpanel
  class="general-expander"
  [expanded]="!$isCollapsed()"
  (expand)="toggleCollapse(false)"
  (collapse)="toggleCollapse(true)">
  <ng-template kendoExpansionPanelTitleDirective>
    <div class="panel-header">
      <h3 class="panel-title">{{ $headerText() }}</h3>
      <h4>({{ formInstances.length }})</h4>
    </div>
  </ng-template>
  <kendo-listview [data]="formInstances | sort: sortConfigs">
    <ng-template let-dataItem="dataItem" let-isFirst="isFirst" kendoListViewItemTemplate>
      @if (!isFirst) {
        <hr class="k-m-2 k-mx-0" />
      }
      <unity-card-form-instance-shared
        class="item"
        [formInstance]="dataItem"
        [highlightedRecordId]="$highlightedRecordId()"
        (scrollToEvent)="handleScrollToEvent()" />
    </ng-template>
    <ng-template let-dataItem kendoListViewFooterTemplate [unityTyped]="formInstances">
      @if (formInstances.length === 0) {
        <div class="k-text-center">
          <h4>{{ $noRecordsText() }}</h4>
        </div>
      }
    </ng-template>
  </kendo-listview>
</kendo-expansionpanel>
